module.exports = __webpack_public_path__ + "static/media/banner@2x.4728611f.png";